import { FC } from 'react';
import { IconProps } from 'types';

export const CloseIcon: FC<IconProps> = ({ width = 18, height = 15, fill = '#ffffff' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.63534 13.7955C2.196 13.3562 2.196 12.6438 2.63534 12.2045L13.7723 1.06757C14.2116 0.628232 14.9239 0.628231 15.3633 1.06757C15.8026 1.50691 15.8026 2.21922 15.3633 2.65856L4.22633 13.7955C3.78699 14.2348 3.07468 14.2348 2.63534 13.7955Z"
      fill={fill}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.63615 0.795495C3.07549 0.356155 3.7878 0.356155 4.22714 0.795495L15.3641 11.9324C15.8034 12.3718 15.8034 13.0841 15.3641 13.5234C14.9247 13.9628 14.2124 13.9628 13.7731 13.5234L2.63615 2.38649C2.19681 1.94715 2.19681 1.23483 2.63615 0.795495Z"
      fill={fill}
    />
  </svg>
);
